import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const airloomApi = createApi({
  reducerPath: "airloomApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API_BASE_URL,
    credentials: "include",
    prepareHeaders: (headers) => {
      headers.set("Accept", "application/json");
      return headers;
    },
    paramsSerializer: (params) => {
      const searchParams = new URLSearchParams();
      Object.entries(params).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          // Create repeated parameters for arrays
          value.forEach((item) => searchParams.append(key, String(item)));
        } else if (value !== undefined && value !== null) {
          searchParams.append(key, String(value));
        }
      });
      return searchParams.toString();
    },
  }),
  endpoints: () => ({}),
});
